module.exports = __webpack_public_path__ + "img/2_2-residenziale-scuola-0.aa23c744.png";